<div class="page">
  <div class="sidenav">
    <app-search-scenarios-form-container
      [regionsViewModel]="regionsViewModel$ | async"
      [sourcesViewModel]="sourcesViewModel$ | async"
      [basecasesViewModel]="basecasesViewModel$ | async"
      [subtypesViewModel]="subtypesViewModel$ | async"
      [weatherYearsViewModel]="weatherYearsViewModel$ | async"
      [marketAreasViewModel]="marketAreasViewModel$ | async"
    ></app-search-scenarios-form-container>
  </div>

  <div class="content psf-layer">
    <div class="psf-flex-left" style="max-height:3em">
      <h3>Price scenarios results</h3>
      <p class="margin-auto accent-text">All data are for internal use only</p>
    </div>

    <div class="psf-flex-left">
      <div class="width-fit-content">
        <app-scenario-unit-form></app-scenario-unit-form>
      </div>

      @if (scenariosViewModelSignal().scenarios.length > 0) {
        <button
          class="margin-auto"
          style="margin-top: 20px"
          tds-button
          variant="secondary"
          (click)="exportSelectedScenarios()"
          [disabled]="selectedScenariosSignal().length <= 0"
          data-testid="export-button"
        >
          @if (!exportSelectedScenariosSignal().isExporting) {
            <tds-icon name="download"></tds-icon>
          } @else {
            <tds-icon name="progress_activity" class="spinner" data-testid="spinner" />
          }
          Export Excel file
        </button>
      }
    </div>

    <div tds-tile variant="auto">
      <app-scenarios-result-list-container
        [viewModel]="scenariosViewModel$ | async"
      ></app-scenarios-result-list-container>
    </div>

    @if (scenariosViewModelSignal().scenarios.length > 0) {
      <div>
        <div tds-tile variant="auto">
          <div class="psf-flex-right" style="max-height: 2em">
            <h4>
              {{ previewTitle() }}
            </h4>

            <div class="data-mode-controls">
              <mat-form-field appearance="outline">
                <mat-select [ngModel]="historicalDataMode()" (ngModelChange)="onHistoricalDataModeChange($event)">
                  @for (mode of historicalDataModes; track mode) {
                    <mat-option [value]="mode">
                      {{ mode }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <tds-segmented-control
                (selectedIndexChange)="switchView($event)"
                [selectedIndex]="displaySelected()"
              >
                <button tds-segmented-control-option><tds-icon name="table" />Table</button>
                <button tds-segmented-control-option><tds-icon name="show_chart" />Chart</button>
              </tds-segmented-control>
            </div>
          </div>

          @if (this.display() === 'CHART') {
            <app-prices-chart></app-prices-chart>
          } @else {
            <app-scenarios-price-list></app-scenarios-price-list>
          }
        </div>
      </div>
    }
  </div>
</div>
